import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.product';

const translations = {
    'product': 'Termékek',
    'edit.title': 'Termék szerkesztése',
    'not_found': 'A termék nem található',
    'id.title': 'ID',
    'ext_id.title': 'GRoby ID',
    'name.title': 'Név',
    'status.title': 'Státusz',
    'price.title': 'Ár',
    'special_price.title': 'Akciós ár',
    'special_to_date.title': 'Akciós -ig',
    'is_mpl.title': 'Csomagfutár',
    'is_mpl.hint': 'Csomagfutárral szállítható?',
    'news_from_date.title': 'Újdonság -tól',
    'news_to_date.title': 'Újdonság -ig',

    'gift_message_available.title': 'Ajándéküzenet',
    'gift_message_available.hint': 'Ajándéküzenet megadható?',
    'description.title': 'Termékleírás',
    'components.title': 'Összetevők',
    'nutrition_data.title': 'Tápanyagok',
    'meta_title.title': 'Meta title',
    'meta_description.title': 'Meta description',
    'meta_keywords.title': 'Meta keywords',
    'min_expiry_days.title': 'Lejárat',
    'min_expiry_days.hint': 'Napban',
    'sliceable.title': 'Szeletelhető',
    'weight.title': 'Tömeg',
    'alternative_quantity_scale.title': 'Alternatív mennyiség léptetési egysége',
    'alternative_quantity_minimum.title': 'Alternatív mennyiségi minimum',
    'alternative_quantity_exchange_rate.title': 'Alternatív átváltási arány',
    'alternative_quantity_name.title': 'Alternatív mennyiség neve',
    'alternative_quantity_name.please_select': 'Kérjük válassz...',
    'weight.hint': 'Grammban',
    'default_quantity_name.title': 'Alapértelmezett mennyiségi egység neve',
    'default_quantity_minimum.title': 'Alapértelmezett mennyiségi minimum',
    'default_quantity_scale.title': 'Alapértelmezett mennyiség léptetési egysége',
    'is_qty_decimal.title': 'Tört szám lehet?',
    'webshop_only_price.title': 'Csak internetes ár?',

    'defaultImage.label': 'Alapértelmezett kép',
    'defaultImage.change.label': 'Alapértelmezett kép cseréje',
    'image.add.label': 'További kép feltöltése',
    'noDefaultImage': 'Nincs alapértelmezett kép',
    'images.label': 'További képek',
    'defaultCategory.label': 'Alapértelmezett kategória',
    'addCategory.label': 'Kategória hozzáadása',
    'categories.label': 'További kategóriák',

    'tabs.default': 'Alapadatok',
    'tabs.attributes': 'Termékparaméterek',
    'tabs.categories': 'Kategóriák',
    'tabs.images': 'Képek',
    'tabs.info': 'Egyéb információ',

    'filter.is_new': 'Újdonság',
    'filter.is_special': 'Akciós',
    'filter.is_mpl': 'Csomagfutár',
    'filter.name': 'Terméknév',
    'filter.ext_id': 'GRoby ID',
    'filter.category': 'Kategória',
    'filter.productStatus': 'Státusz',

    'info.id': 'ID',
    'info.ext_id': 'GRoby ID',
    'info.url_key': 'URL',
    'info.smarturl': 'Régi URL ',
    'info.price': 'Ár',
    'info.price_unit': 'Áregység',
    'info.price_per_unit': 'Egységár',
    'info.vat': 'Áfa',
    'info.special_price': 'Akciós ár',
    'info.special_from_date': 'Akció érvényes -tól',
    'info.special_to_date': 'Akció érvényes -ig',
    'info.news_to_date': 'Újdonság -ig:',
    'info.barcodes': 'Vonalkód',
    'info.alternative_quantity_name': 'Alternatív mennyiség',
    'info.default_quantity_name': 'Alapértelmezett mennyiség',
    'info.default_quantity_minimum': 'Alapértelmezett mennyiségi minimum',
    'info.default_quantity_scale': 'Alapértelmezett mennyiség léptetési egysége',
    'info.gift_message_available': 'Ajándékkártya, masni',
    'info.updated_at': 'Frissítve',

    'notification.move.success': 'Sikeres átrendezés',
    'notification.change.success': 'Sikeres csere',
    'notification.upload.success': 'Sikeres feltöltés',
    'notification.delete.success': 'Sikeres törlés',
    'notification.error': 'Hiba történt',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/Product/lang/hu.ts